var _path;
import * as React from "react";
function SvgAngleLightLeft(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.198 19.018l13.61-13.403a1.388 1.388 0 011.964 0l.82.82a1.388 1.388 0 010 1.965L23.774 20l11.808 11.6a1.388 1.388 0 010 1.964l-.82.82a1.388 1.388 0 01-1.964 0l-13.61-13.402a1.398 1.398 0 01.01-1.964zm-14.79 1.964L18.02 34.385a1.388 1.388 0 001.964 0l.82-.82a1.388 1.388 0 000-1.965L8.985 20 20.792 8.4a1.388 1.388 0 000-1.964l-.82-.82a1.388 1.388 0 00-1.964 0L4.398 19.017a1.398 1.398 0 00.01 1.964z"
  })));
}
export default SvgAngleLightLeft;